import '@/assets/ai-modal.css';
import CancelModal from '@/app/common/components/CancelModal';
import { useAppContext } from '@/Main';
import { breakpointsMediaQuery, useMediaQuery } from '@/helpers/utils';
import { Modal } from '@/components/common/AppModal';
import { Card } from 'react-bootstrap';
import AiModalContent from './components/AiModalContent';
import AiModalHeader from './components/AiModalHeader';
import AiModalMessageForm from './components/AiModalMessageForm';
import AiModalToolbar from './components/AiModalToolbar';
import { useAiModal } from './hooks/useAiModal';

const AiModal = () => {
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);
  const {
    config: { isRTL }
  } = useAppContext() as { config: { isRTL: boolean } };

  const {
    key,
    payload,
    modalRef,
    messages,
    size,
    canUseAi,
    needsApiKeySetup,
    isFetchingHistoryList,
    isFetchingHistoryDetails,
    hasKeywordHistory,
    isHistoryListLoaded,
    isFetchingAnalysis,
    suppressAnalysisLoading,
    isSendingMessage,
    isResearching,
    selectedTimeRange,
    setSelectedTimeRange,
    selectedType,
    setSelectedType,
    handleClose,
    handleReanalyze,
    handleResearch,
    handleSendMessage,
    handleDeleteHistoryRequest,
    handleDeleteHistoryConfirm,
    showDeleteHistoryConfirm,
    setShowDeleteHistoryConfirm,
    showInsufficientBalance,
    showNoActiveApiKeyAlert,
    setShowNoActiveApiKeyAlert,
    formWarningMessage,
    setFormWarningMessage,
    isDeletingHistory,
    startResize
  } = useAiModal();

  const displayKeyword = payload?.keyword
    ? decodeURIComponent(payload.keyword)
    : '';

  const isBlockingAccessAlert =
    showInsufficientBalance ||
    (showNoActiveApiKeyAlert && messages.length === 0) ||
    (Boolean(formWarningMessage) && messages.length === 0) ||
    (needsApiKeySetup && messages.length === 0);

  const showActions = !isBlockingAccessAlert;

  const isCompactAccessAlert =
    isBlockingAccessAlert && messages.length === 0;

  const COMPACT_ACCESS_ALERT_HEIGHT = 260;

  const modalHeight = isCompactAccessAlert
    ? COMPACT_ACCESS_ALERT_HEIGHT
    : isMdUp
      ? size.height
      : '85vh';

  return (
    <Modal
      dialogClassName="note-modal-dialog"
      contentClassName="note-modal"
      show={key === 'ai_notes'}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <style>{`
        .chat-editor-area .message-input {
          height: 100% !important;
          min-height: 100% !important;
        }
      `}</style>
      <div
        ref={modalRef}
        style={{
          width: isMdUp ? size.width : '90vw',
          height: modalHeight,
          position: 'relative'
        }}
      >
        <Card
          className="overflow-hidden rounded-4 d-flex flex-column h-100"
          style={{ height: '100% !important' }}
        >
          <AiModalHeader keyword={payload?.keyword} onClose={handleClose} />

          <AiModalContent
            isMdUp={isMdUp}
            size={size}
            keyword={payload?.keyword}
            messages={messages}
            isFetchingHistoryList={isFetchingHistoryList}
            isFetchingHistoryDetails={isFetchingHistoryDetails}
            hasKeywordHistory={hasKeywordHistory}
            isHistoryListLoaded={isHistoryListLoaded}
            isFetchingAnalysis={isFetchingAnalysis}
            suppressAnalysisLoading={suppressAnalysisLoading}
            showInsufficientBalance={showInsufficientBalance}
            showNoActiveApiKeyAlert={showNoActiveApiKeyAlert}
            onCloseNoActiveApiKeyAlert={() => setShowNoActiveApiKeyAlert(false)}
            formWarningMessage={formWarningMessage}
            onCloseFormWarning={() => setFormWarningMessage(null)}
            needsApiKeySetup={needsApiKeySetup}
            canUseAi={canUseAi}
          />

          {showActions && (
            <>
              <AiModalToolbar
                messages={messages}
                keyword={payload?.keyword}
                isFetchingAnalysis={isFetchingAnalysis}
                isResearching={isResearching}
                isDeletingHistory={isDeletingHistory}
                hasKeywordHistory={hasKeywordHistory}
                selectedTimeRange={selectedTimeRange}
                selectedType={selectedType}
                onTimeRangeChange={setSelectedTimeRange}
                onTypeChange={setSelectedType}
                onReanalyze={handleReanalyze}
                onResearch={handleResearch}
                onDeleteHistory={handleDeleteHistoryRequest}
              />
              <AiModalMessageForm
                isRTL={isRTL}
                isSendingMessage={isSendingMessage}
                onSendMessage={handleSendMessage}
              />
            </>
          )}
        </Card>

        {isMdUp && !isCompactAccessAlert && (
          <div
            className="allaho_akbar_zIndex custom-gutter"
            onMouseDown={startResize}
          />
        )}
      </div>

      <CancelModal
        show={showDeleteHistoryConfirm}
        setShow={setShowDeleteHistoryConfirm}
        title="حذف تاریخچه تحلیل"
        submitTitle="آره، حذف بشه"
        submitFunc={handleDeleteHistoryConfirm}
        isSubmitting={isDeletingHistory}
        desc={
          displayKeyword
            ? `آیا مطمئن هستید می‌خواهید تاریخچه گفتگوی تحلیل «${displayKeyword}» حذف شود؟`
            : 'آیا مطمئن هستید می‌خواهید تاریخچه گفتگوی تحلیل این کلمه حذف شود؟'
        }
      />
    </Modal>
  );
};

export default AiModal;
